import React, { Component } from 'react';
import moment from 'moment';

export default class SummarySlide extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }

        this.fancyDateFromDateIndex = this.fancyDateFromDateIndex.bind(this);
        this.displayMetricInfo = this.displayMetricInfo.bind(this);
        this.dateIndexToDate = this.dateIndexToDate.bind(this);
    }

    dateIndexToDate(dateIndex) {
		return moment(dateIndex + "", "YYYYMMDD").format("MM/DD/YYYY");
	}

    fancyDateFromDateIndex(dateIndex) {

        if (dateIndex === null) {
            return "";
        }

        let monthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        let diString = dateIndex + '';
        let yString = diString.substring(0, 4);
        let mString = diString.substring(4, 6).replace(/^0+/g, '');
        let dString = diString.substring(6, 8).replace(/^0+/g, '');

        return monthList[parseInt(mString) - 1] + " " + dString + ", " + yString;
    }

    displayMetricInfo(kpi, metric, showOverUnder, showTickets) {
        if (kpi === null || metric === null || kpi === undefined || metric === undefined) {
            return '';
        }

        let overUnder = metric.isLowerBetter ? " under " : " over ";
        let valuePrefix = kpi.type === 'MNY' ? "$" : "";
        let value = metric.value;
        let valueSuffix = kpi.type === 'PCT' ? "%" : "";

        let ticketString = " | Ticket value: " + metric.ticketCount + (metric.isRepeatable ? " Repeatable" : "");

        return kpi.name + (showOverUnder ? overUnder + valuePrefix + value + valueSuffix : "") + (showTickets ? ticketString : "");
    }

    render() {

        let form = this.props.form;
        let navMap = this.props.navMap;
        let kpiMapReverse = this.props.kpiMapReverse;

        let kpi1 = form.metric[this.props.kpiField] === null ? null : kpiMapReverse[form.metric[this.props.kpiField]];
        let kpi2 = form.metric2[this.props.kpiField] === null ? null : kpiMapReverse[form.metric2[this.props.kpiField]];
        let kpi3 = form.metric3[this.props.kpiField] === null ? null : kpiMapReverse[form.metric3[this.props.kpiField]];
        let kpiq = form.qualifier[this.props.kpiField] === null ? null : kpiMapReverse[form.qualifier[this.props.kpiField]];

        let showOverUnder = form.type === "raffle";
        let showTickets = form.type === "raffle";

        let lrPosition = this.props.position < this.props.slideNumber ? '-100vw' : this.props.position > this.props.slideNumber ? '100vw' : '0vw';
        let cardHeight = this.props.position === this.props.slideNumber ? (form.type === 'raffle' ? 50.5 : 42.5) : 0;

        return (
            <div className={"gc-slide"} style={{ left: lrPosition, overflow: "hidden", height: cardHeight + 'rem' }}>
                <div className={"gc-review-header scope"}>
                    <div className={"gc-review-header-text"}>Scope</div>
                    {this.props.noEdit ? <div></div> : <div className={"material-icons gc-review-header-edit"} onClick={this.props.navigate.bind(null, navMap['scope'])}>edit</div>}
                    <div className={"gc-review-underheader"}>
                        {form.scope === 'ca' ? 'Account Wide' : form.scope === 'location' ? 'Location Wide' : 'Group Wide'}
                    </div>
                    <div className={"gc-review-underheader"}>
                        {(form.scope === "ca" ? "" : form.scope === 'location' ? "Location: " : "Group: ") + (form.scope === 'ca' ? '' : this.props.scopeMapReverse[form[this.props.scopeField]])}
                    </div>
                </div>
                <div className={"gc-review-header contest-type"}>
                    <div className={"gc-review-header-text"}>Contest Type</div>
                    {this.props.noEdit ? <div></div> : <div className={"material-icons gc-review-header-edit"} onClick={this.props.hasType ? this.props.navigate.bind(null, navMap['type']) : () => { }}>{this.props.hasType ? "edit" : null}</div>}
                    <div className={"gc-review-underheader"}>{form.type === 'ranked' ? "Ranked" : "Raffle"}</div>
                </div>
                <div className={"gc-review-header cidentity"}>
                    <div className={"gc-review-header-text"}>Identity</div>
                    {this.props.noEdit ? <div></div> : <div className={"material-icons gc-review-header-edit"} onClick={this.props.navigate.bind(null, navMap['identity'])}>edit</div>}
                    <div className={"gc-review-underheader"}>{'Name: ' + form.name}</div>
                    <div className={"gc-review-underheader"}>{'Description: ' + form.description}</div>
                </div>
                <div className={"gc-review-header ctime"}>
                    <div className={"gc-review-header-text"}>Time</div>
                    {this.props.noEdit ? <div></div> : <div className={"material-icons gc-review-header-edit"} onClick={this.props.navigate.bind(null, navMap['time'])}>edit</div>}
                    <div className={"gc-review-underheader"}>
                        {'The contest begins ' + (this.fancyDateFromDateIndex(form.fromDateIndex)) + " and ends " + (this.fancyDateFromDateIndex(form.toDateIndex))}
                        
                    </div>
                </div>
                <div className={"gc-review-header cmetrics"}>
                    <div className={"gc-review-header-text"}>{"Objective Metric" + (form.type === 'raffle' ? 's' : '')}</div>
                    {this.props.noEdit ? <div></div> : <div className={"material-icons gc-review-header-edit"} onClick={this.props.navigate.bind(null, navMap['metrics'])}>edit</div>}
                    <div className={"gc-review-underheader"}>{(form.type === 'raffle' ? "Quantity: " + form.metricCount : '')}</div>
                    <div className={"gc-review-underheader double-line"}>
                        {
                            this.displayMetricInfo(kpi1, form.metric, showOverUnder, showTickets)
                        }
                    </div>
                    <div className={"gc-review-underheader double-line"}>
                        {
                            form.metricCount > 1 ? this.displayMetricInfo(kpi2, form.metric2, showOverUnder, showTickets) : form.type === 'raffle' ? 'No Second Objective' : ''
                        }
                    </div>
                    <div className={"gc-review-underheader double-line"}>
                        {
                            form.metricCount > 2 ? this.displayMetricInfo(kpi3, form.metric3, showOverUnder, showTickets) : form.type === 'raffle' ? 'No Third Objective' : ''
                        }
                    </div>
                </div>
                <div className={"gc-review-header cminmetrics double-line" + (form.type === 'ranked' ? ' ranked-short' : '')}>
                    <div className={"gc-review-header-text"}>Qualifier Metric</div>
                    {this.props.noEdit ? <div></div> : <div className={"material-icons gc-review-header-edit"} onClick={this.props.navigate.bind(null, navMap['qualifier'])}>edit</div>}
                    <div className={"gc-review-underheader"}>
                        {
                            form.hasQualifier ? this.displayMetricInfo(kpiq, form.qualifier, true, false) : 'No Qualifier'
                        }
                    </div>
                </div>
            </div>
        );
    }
}